export const HERMES_ICON = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="hb-icon">
  <!-- Wing helmet -->
  <path d="M12 2C8.5 2 6 4.5 6 7c0 1.5.5 2.8 1.5 3.8L6 14h12l-1.5-3.2C17.5 9.8 18 8.5 18 7c0-2.5-2.5-5-6-5z" fill="currentColor" opacity="0.2"/>
  <path d="M12 2C8.5 2 6 4.5 6 7c0 1.5.5 2.8 1.5 3.8L6 14h12l-1.5-3.2C17.5 9.8 18 8.5 18 7c0-2.5-2.5-5-6-5z" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linejoin="round"/>
  <!-- Wings -->
  <path d="M6 6.5C4.5 5 2 5 2 7s1.5 3 3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M18 6.5C19.5 5 22 5 22 7s-1.5 3-3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  <!-- Caduceus staff -->
  <line x1="12" y1="14" x2="12" y2="22" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
  <!-- Snakes -->
  <path d="M9.5 16c1.5 1 3.5 1 5 0" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" fill="none"/>
  <path d="M9.5 19c1.5 1 3.5 1 5 0" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" fill="none"/>
  <!-- Eye -->
  <circle cx="12" cy="7.5" r="1.5" fill="currentColor"/>
</svg>`;

export const HERMES_SKILL_ICON = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="hb-icon">
  <!-- Brain/memory symbol -->
  <path d="M12 3C8 3 5 6 5 9c0 2 1 3.5 2 4.5V16a2 2 0 002 2h6a2 2 0 002-2v-2.5c1-1 2-2.5 2-4.5 0-3-3-6-7-6z" fill="currentColor" opacity="0.15"/>
  <path d="M12 3C8 3 5 6 5 9c0 2 1 3.5 2 4.5V16a2 2 0 002 2h6a2 2 0 002-2v-2.5c1-1 2-2.5 2-4.5 0-3-3-6-7-6z" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linejoin="round"/>
  <!-- Neural connections -->
  <path d="M9 9.5c0-1 .5-2 1.5-2.5M15 9.5c0-1-.5-2-1.5-2.5M10.5 11c.5.5 1.5 1 3 0" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" fill="none"/>
  <!-- Growing roots -->
  <path d="M9 18v2M12 18v3M15 18v2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  <!-- Sparkle -->
  <circle cx="8" cy="6" r="0.8" fill="currentColor"/>
  <circle cx="16" cy="6" r="0.8" fill="currentColor"/>
</svg>`;

export const COPY_ICON = `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="hb-icon-sm">
  <rect x="5" y="5" width="8" height="8" rx="1.5" stroke="currentColor" stroke-width="1.5" fill="none"/>
  <path d="M3 10V3.5A1.5 1.5 0 014.5 2H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>`;

export const CHECK_ICON = `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="hb-icon-sm">
  <path d="M3 8.5l3.5 3.5L13 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

export const DOWNLOAD_ICON = `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="hb-icon-sm">
  <path d="M8 2v8m0 0l-3-3m3 3l3-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M3 12v1.5a1 1 0 001 1h8a1 1 0 001-1V12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>`;

export const CLOSE_ICON = `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="hb-icon-sm">
  <path d="M4 4l8 8m0-8l-8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>`;

export const TERMINAL_ICON = `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="hb-icon-sm">
  <rect x="1" y="2" width="14" height="12" rx="2" stroke="currentColor" stroke-width="1.5" fill="none"/>
  <path d="M4 6l3 2.5L4 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9 11h3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>`;
